import { GetVerifyCode , BindingMobile , GetMobileBindStatus } from "@/api/BuildPhone";
const state = {
    GetCode:{},
    SubmitPhone:{},
    GetMobileBindStatus:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  GetVerifyCode({ commit },data) {
    return new Promise((resolve)=>{
      GetVerifyCode(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetVerifyCode',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      });
    })
  },
  BindingMobile({ commit },data) {
    return new Promise((resolve)=>{
      BindingMobile(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'BindingMobile',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      });
    })
  },
  GetMobileBindStatus({ commit },data) {
    return new Promise((resolve)=>{
      GetMobileBindStatus(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetMobileBindStatus',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
